<template>
  <!-- 地區主題精選 -->
  <v-sheet v-resize="onResize" class="themes__swiper" elevation="0" rounded>
    <div class="swiper__header wd-flex wd-justify-between">
      <h3 class="header__title">{{ title }}</h3>

      <div v-if="!isMobile" class="swiper-btn-group d-flex">
        <v-btn
          class="swiper-button swiper-prev mr-3 pa-0"
          :class="{ disabled: disabledPrevBtn }"
          min-width="32"
          height="32"
          variant="text"
          aria-label="Prev Button"
          @click="prevSwiper"
        >
          <FunnowSvgIcon max-width="24" :image-path="'chevron-left.svg'" />
        </v-btn>

        <v-btn
          class="swiper-button swiper-next pa-0"
          :class="{ disabled: disabledNextBtn }"
          min-width="32"
          height="32"
          variant="text"
          aria-label="Next Button"
          @click="nextSwiper"
        >
          <FunnowSvgIcon max-width="24" :image-path="'chevron-right.svg'" />
        </v-btn>
      </div>
    </div>

    <div class="swiper__container mt-2">
      <!--
        Add `is-ssr` class only during SSR to apply additional styles for `Grid` layout.
        Swiper's Grid module doesn't have styles during SSR, causing layout differences after hydration.
        These additional styles must be removed in CSR, otherwise swiper's slide calculation will be incorrect.
      -->
      <swiper
        ref="relatedThemesSwiper"
        class="swiper wd-h-80"
        :class="{ 'is-ssr': isSSR }"
        v-bind="swiperOption"
        @swiper="initSwiper"
        @slide-change-transition-end="onSlideChangeEnd"
      >
        <swiper-slide v-for="theme in themeItems" :key="theme.id" class="wd-flex-1 wd-max-h-146px">
          <div v-if="theme.id">
            <NuxtLink :to="getThemeURL(theme.id)">
              <v-card class="theme__card" flat max-height="146">
                <v-img class="theme__image" :src="getImage(theme.cover_image)" cover max-width="234" height="146">
                  <div class="wd-h-full wd-w-full wd-bg-black wd-bg-opacity-40 wd-flex wd-justify-center wd-items-center">
                    <span class="wd-text-white wd-text-olg wd-font-medium wd-text-center">{{ theme.name }}</span>
                  </div>
                </v-img>
              </v-card>
            </NuxtLink>
          </div>
          <v-skeleton-loader v-else max-width="234" max-height="146" type="image" />
        </swiper-slide>
      </swiper>
    </div>
  </v-sheet>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Grid } from 'swiper/modules'

import FunnowSvgIcon from '@/components/icons/funnow-svg-icon'

export default {
  name: 'ThemesSwiper',
  components: {
    Swiper,
    SwiperSlide,
    FunnowSvgIcon,
  },
  props: {
    isMobile: { type: Boolean, default: false },
    title: { type: String, default: '' },
    regionId: { type: [String, Number], default: '' },
    items: { type: Array, default: () => [] },
  },
  setup() {
    const isSSR = import.meta.env.SSR
    const { swiper, disabledPrevBtn, disabledNextBtn, initSwiper, prevSwiper, nextSwiper, switchSwiperBtnStatus, onResize, onSlideChangeEnd } =
      useSwiperFactory()
    const localePath = useLocalePath()

    return {
      isSSR,
      swiper,
      disabledPrevBtn,
      disabledNextBtn,
      initSwiper,
      prevSwiper,
      nextSwiper,
      switchSwiperBtnStatus,
      onResize,
      onSlideChangeEnd,
      localePath,
    }
  },
  data() {
    return {
      swiperOption: {
        modules: [Grid],
        grid: {
          fill: 'column',
          rows: 2,
        },
        slidesPerView: 'auto',
        slidesOffsetAfter: 20,
        spaceBetween: 8,
        breakpoints: {
          420: {
            spaceBetween: 20,
          },
        },
      },
    }
  },
  computed: {
    themeItems() {
      return this.items.length > 0 ? this.items : 10
    },
  },
  methods: {
    getImage(path) {
      return `${this.$config.public.CDN_URI}${path}`
    },
    getThemeURL(themeID) {
      return this.regionId && themeID ? this.localePath({ name: 'regions-rid-themes-id', params: { rid: this.regionId, id: themeID } }) : ''
    },
    updateSwiperButton() {
      this.$nextTick(() => {
        this.switchSwiperBtnStatus()
      })
    },
  },
}
</script>

<style scoped lang="scss">
.themes__swiper {
  padding: 0;
  color: $black50;

  .swiper__header {
    padding: 12px 0;

    .header__title {
      margin-bottom: 0;
      font-size: 24px;
      font-weight: 500;
      line-height: 32px;

      @include xxs {
        font-size: 20px;
      }
    }

    .swiper-btn-group {
      .swiper-button {
        &.disabled {
          color: $gray60;
          pointer-events: none;
        }
      }
    }
  }

  .swiper__container {
    padding: 12px 0;

    .swiper-container {
      height: 312px;
    }
    .swiper-slide {
      height: 146px;
    }

    .theme__card,
    .swiper-slide {
      width: 233px;
    }

    .theme__card {
      .theme {
        &__image {
          border-radius: 4px;
        }

        &__title {
          text-align: center;
          font-size: 17px;
          font-weight: 500;
          line-height: 24px;
        }
      }
    }
  }

  :deep(.swiper) {
    &.is-ssr {
      .swiper-wrapper {
        @apply wd-flex-col wd-flex-wrap wd-gap-2 xs:wd-gap-5;
      }
    }
  }
}
</style>
